/* Shop Coupons - modal + lazy JsBarcode
 *
 * Trigger button is in shop-hero section, modal is in shop-coupons section.
 * They're in different parent containers, so we look them up at document level.
 */
(function () {
  'use strict';

  var JSBARCODE_URL = 'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js';
  var jsbarcodeLoading = null;

  function loadJsBarcode() {
    if (window.JsBarcode) return Promise.resolve();
    if (jsbarcodeLoading) return jsbarcodeLoading;

    jsbarcodeLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = JSBARCODE_URL;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () {
        jsbarcodeLoading = null;
        reject(new Error('Failed to load JsBarcode'));
      };
      document.head.appendChild(s);
    });
    return jsbarcodeLoading;
  }

  function renderBarcodes(scope) {
    if (!window.JsBarcode) return;
    var svgs = (scope || document).querySelectorAll('svg[data-barcode]');
    svgs.forEach(function (svg) {
      if (svg.dataset.rendered === '1') return;
      var code = svg.dataset.code;
      var format = svg.dataset.format || 'CODE128';
      if (!code) return;
      try {
        window.JsBarcode(svg, code, {
          format: format,
          width: 2,
          height: 80,
          displayValue: true,
          fontSize: 14,
          margin: 6,
          background: '#ffffff',
          lineColor: '#000000'
        });
        svg.dataset.rendered = '1';
      } catch (err) {
        svg.innerHTML = '<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-family="monospace" font-size="14">' + escapeXml(code) + '</text>';
        svg.setAttribute('viewBox', '0 0 200 40');
        if (window.console && console.warn) {
          console.warn('[shop-coupons] Barcode render failed for code "' + code + '" with format ' + format, err);
        }
      }
    });
  }

  function escapeXml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  function trapFocus(modal, e) {
    var focusables = modal.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  var initialized = false;
  var lastFocused = null;

  function init() {
    // Look up trigger and modal at document level (they live in separate sections)
    var triggers = document.querySelectorAll('[data-coupon-trigger]');
    var modal = document.querySelector('[data-coupon-modal]');

    if (!triggers.length || !modal) return;
    if (modal.dataset.initialized === '1') return;
    modal.dataset.initialized = '1';

    function updateOverflowState() {
      var body = modal.querySelector('.shop-coupons__modal-body');
      if (!body) return;
      // If content fits without scroll, hide the fade gradient
      var atBottom = (body.scrollTop + body.clientHeight) >= (body.scrollHeight - 4);
      var hasOverflow = body.scrollHeight > body.clientHeight + 4;
      if (!hasOverflow || atBottom) {
        body.classList.add('shop-coupons__modal-body--no-overflow');
      } else {
        body.classList.remove('shop-coupons__modal-body--no-overflow');
      }
    }

    function openModal(srcTrigger) {
      lastFocused = srcTrigger || document.activeElement;
      modal.hidden = false;
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      document.body.classList.add('shop-coupons-modal-open');

      loadJsBarcode()
        .then(function () {
          renderBarcodes(modal);
          // After barcodes render, content size may have changed
          setTimeout(updateOverflowState, 50);
        })
        .catch(function (err) {
          if (window.console && console.error) console.error(err);
        });

      var closeBtn = modal.querySelector('.shop-coupons__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);

      // Initial check
      setTimeout(updateOverflowState, 0);

      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      modal.hidden = true;
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      document.body.classList.remove('shop-coupons-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeModal();
      } else if (e.key === 'Tab') {
        trapFocus(modal, e);
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () { openModal(trigger); });
    });
    modal.querySelectorAll('[data-coupon-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    // Update scroll fade visibility on scroll
    var body = modal.querySelector('.shop-coupons__modal-body');
    if (body) {
      body.addEventListener('scroll', updateOverflowState, { passive: true });
    }
    // Re-check on resize (orientation change etc.)
    window.addEventListener('resize', function () {
      if (!modal.hidden) updateOverflowState();
    });

    initialized = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function () {
    // Reset state and re-init
    var modal = document.querySelector('[data-coupon-modal]');
    if (modal) { delete modal.dataset.initialized; }
    initialized = false;
    init();
  });
})();